<template>
  <div>
    <div class="box">
      <div class="box-header">
        <div class="pull-right m-t-xs">
          <dropdown displayName="locationName" valueName="locationName" v-model="idcSelectedItem" :datasource="idcList" :isSelectionFirstData="true" inline="inline" :width="100"/>
        </div>
        <h3>출입 티켓 선택</h3>
        <small>IDC 입실을 위해 예약하신 티켓을 선택해 주세요</small>
      </div>

      <div>
        <div class="tbody scroll-wrap" style="height:360px; overflow: auto"  data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark'}">
          <table class="tbl v-tbl" style="border-top: 1px solid #e2e2e2; border-bottom: 2px solid #e2e2e2;">
            <colgroup>
              <col width="50px">
              <col width="100px">
              <col width="auto">
              <col width="100px">
              <col width="auto">
            </colgroup>
            <tbody v-for="rev in filteredList" style="border-bottom: 2px solid #e2e2e2; ">
                <tr>
                  <th rowspan="3" style="vertical-align: middle; text-align: center;">
                    <label class="md-check" style="margin-right: 0px; padding-left: 1.25rem;">
                      <!--<input type="checkbox" checked="" />-->
                      <input type="radio" name="uuid" checked="checked" v-model="selectedUuid" :value="rev.uuid">
                      <i class="blue"></i>
                    </label>
                  </th>
                  <th class="border-l">IDC</th>
                  <td>{{rev.locationName}}</td>

                  <th class="border-l">출입기간</th>
                  <td>{{getDueDate(rev.fromDate, rev.toDate)}}</td>
                </tr>
                <tr>
                  <th class="border-l">반입 요청 자산</th>
                  <td colspan="3">
                    <span class="tag line-type mr-6" style="font-weight: normal;" v-for="asset in rev.assetList">
                      <!--노트북(MacBook Pro 13")-->
                      {{asset.visitorAssetCode.assetStr}}({{asset.assetManufacturer}} {{asset.assetModel}})
                    </span>
                  </td>
                </tr>
                <tr>
                  <th class="border-l">출입 요청 위치</th>
                  <td colspan="3">
                    <span class="tag line-type mr-6" style="font-weight: normal;" v-for="location in rev.visitLocation">
                      {{`${location[1]} ${location[2]} ${location[3]}`}}
                    </span>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg blue" :disabled="!selectedUuid" @click="next()">다음
        <i class="icon-arrow-line-right ml-5"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import Dropdown from "@/components/Dropdown.vue";

  export default {
    components: { Dropdown },
    props: ['item', 'data', 'reserve'],
    data() {
      return {
        idcList: [{locationCode: null, locationName: '전체'}],
        idcSelectedItem: null,
        selectedUuid: null
      }
    },
    computed: {
      filteredList(){
        // for(var i  = 0; i < 10; i++) {
        //   this.reserve.push(this.reserve[0])
        // }

        return this.reserve.filter(x => {
           return this.idcSelectedItem == '전체' || this.idcSelectedItem == x.locationName;
        });


      },
    },
    mounted(){
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'dark-thick',
      });
      this.load();
    },
    methods: {
      load(){
        this.$http.get('/api/public/location/idcList')
          .then((result) => {
            this.idcList = [
              ...this.idcList,
              ...result.data.filter((x)=> x.isDeleteYN == "N"),
            ]

          }).catch((e) =>{
            console.log(e);
          })
      },
      next(){

        this.$http.get('/api/private/scanQr/' + this.selectedUuid)
          .then((result) => {
            this.$emit('update:data', result.data);
            this.$emit('changeStep', {item: this.item, tos:this.agreeItems, action: 1})
          }).catch((e) =>{
          console.log(e);
        })
      },
    }
  }
</script>

<style>

</style>
